<section class="departure-return-section rotate180" role="DepartureReturn">
  <pc-departure-return-btn-card
    data-testid="departure-btn"
    [activeImageText]="activeImageText.from"
    [businessUnit]="businessUnit"
    [buttonActiveState]="activeState"
    [buttonDisplayType]="
      activeState === ButtonState.Departure
        ? 'button-active'
        : buttonState >= ButtonState.DepartureCompleted
          ? 'button-completed'
          : 'button-disabled'
    "
    [buttonImage]="buttonImage"
    [buttonImageDesktop]="buttonImageDesktop"
    [buttonState]="buttonState"
    [dateDetail]="datesDetails?.departure"
    [dateEditDescription]="editFromDateDescription"
    [dateEditText]="dateEditText"
    [dateType]="ButtonDateType.Departure"
    [departureAltText]="departureAltText"
    [isLTR]="isLTR"
    [returnAltText]="returnAltText"
    [showButtonImageAirplane]="showButtonImageAirplane"
    [size]="size"
    (editDates)="editSelectedDates($event)"
  >
  </pc-departure-return-btn-card>

  <pc-departure-return-btn-card
    data-testid="return-btn"
    [activeImageText]="activeImageText.to"
    [businessUnit]="businessUnit"
    [buttonActiveState]="activeState"
    [buttonDisplayType]="
      activeState === ButtonState.Return
        ? 'button-active'
        : buttonState >= ButtonState.ReturnCompleted
          ? 'button-completed'
          : 'button-disabled'
    "
    [buttonImage]="buttonImage"
    [buttonImageDesktop]="buttonImageDesktop"
    [buttonState]="buttonState"
    [dateDetail]="datesDetails?.return"
    [dateEditDescription]="editToDateDescription"
    [dateEditText]="dateEditText"
    [dateType]="ButtonDateType.Return"
    [departureAltText]="departureAltText"
    [isLTR]="isLTR"
    [returnAltText]="returnAltText"
    [showButtonImageAirplane]="showButtonImageAirplane"
    [size]="size"
    (editDates)="editSelectedDates($event)"
  >
  </pc-departure-return-btn-card>
</section>
